import { PolicyMessageInfo } from '@pulseops/common'
import React from 'react'
type PolicyDetailContextData = {
  policyMessageInfo: PolicyMessageInfo | undefined | null
}
const defaultValues: PolicyDetailContextData = {
  policyMessageInfo: undefined
}
export const PolicyDetailContext = React.createContext<PolicyDetailContextData>(defaultValues) 